/* Copyright(c) 2020 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
/*@author Anshul Sarade
 *@fileName :customizedLeadReport.js
 *Desc: New UI for Customized Lead Report
 */

import React, { Component } from "react";
import PublisherNavigation from "../layouts/publisherNavPage";
import Footer from "../layouts/footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; //for authentication
import { saveAs } from "file-saver";
import "react-picky/dist/picky.css";
import "./customizedLeadReport.css";
import { Icon, Tooltip } from "antd";
import styled from "styled-components";
// below import added for downloading excel and zip files
import ExcelJS from "exceljs";
import JSZip from "jszip";
import "../campaign/loader.css";
import Picky from "react-picky";
import Select from "react-select";

const XLSX = require("xlsx");
const Swal = require("sweetalert2");

// htmltooltip

const HtmlTooltip = styled(Tooltip)`
     backgroundColor: '#f5f5f9',
     color: 'rgba(0, 0, 0, 0.87)',
     maxWidth: 220,
     fontSize: '12px',
     border: '1px solid #dadde9',
     `;

const leadStatusOptions = [
  { id: "Submitted", name: "Submitted" },//Kiran Dhainje 5944 Updated the Status
  { id: "Delivered", name: "Delivered" },
  { id: "Review-Pending", name: "Review-Pending" },
  { id: "Accepted", name: "Accepted" },
  { id: "Rejected", name: "Rejected" },
  { id: "Extra", name: "Extra" },//Kiran Dhainje 5944 Updated the Status
];

// Anshul 5707 - added options for  campaign status

const campaignStatusOptions = [
  { id: "Active", name: "Active" },
  { id: "Completed", name: "Completed" },
];

class customizedLeadReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      selectedOptions: [],
      filterValues: {},
      clientNames: [],
      campIDs: [],
      totalLeadCount: 0,
      loader: "",
      loader_progress: "",
      campaignLoader: "",
      leadStatus: [],
      selectedFields: [],
      campaignStatus: [], // Anshul 5707 - added to store campaign status

      mandatoryFields: new Set([
        "Client Name",
        "Publisher ID",
        "Campaign ID",
        "Lead Interaction Date",
        "Last Name",
        "First Name",
        "Email",
        "Work Phone",
        "Company Name",
        "Industry",
        "Job Title",
        "Address",
        "City",
        "State",
        "Zip Code",
        "Country",
        "Asset Name",
        "Lead Info ID",
        "Lead Last Updated Date",
        "Lead Uploaded Date",
        "Lead Status",
      ]),

      // All  fields
      allFields: [
        "Client Name",
        "Publisher ID",
        "Campaign ID",
        "Campaign Name",
        "Allocation ID",
        "Lead Interaction Date",
        "Last Name",
        "First Name",
        "Email",
        "Work Phone",
        "Alternate Phone No",
        "LinkedIn",
        "Company Name",
        "LinkedIn Company Name",
        "Industry",
        "Company Employee Size",
        "Company Revenue",
        "Job Title",
        "LinkedIn Job Title",
        "Job Level",
        "Job Function",
        "Address",
        "Street",
        "City",
        "State",
        "Zip Code",
        "Country",
        "Asset ID",
        "Asset Name",
        "Domain",
        "Comments",
        "IP",
        "Extra 1",
        "Extra 2",
        "Extra 3",
        "Extra 4",
        "Extra 5",
        "Extra 6",
        "Extra 7",
        "Extra 8",
        "Extra 9",
        "Extra 10",
        "Extra 11",
        "Extra 12",
        "Extra 13",
        "Extra 14",
        "Extra 15",
        "Extra 16",
        "Extra 17",
        "Extra 18",
        "Extra 19",
        "Extra 20",
        "Extra 21",
        "Extra 22",
        "Extra 23",
        "Extra 24",
        "Extra 25",
        "Extra 26",
        "Extra 27",
        "Extra 28",
        "Extra 29",
        "Extra 30",
        "Email Status",
        "Address Link",
        "Device",
        "ESP Status",
        "ESP Name",
        "Internal QA",
        "Asset Sent By",
        "Contact Number Link",
        "DMA Name",
        "Reviewed by the Agency",
        "Reviewed by Quality",
        "Reviewed by DMA TL",

        "Lead Info ID",
        "Lead Last Updated Date",
        "Lead Uploaded Date",
        "Lead Status",
      ],
    };
    this.dropdownRef = React.createRef();
  }

  fetchFilterOptions = (updatedFilterValues) => {
    //Nilesh-5733-Add loader
    this.setState({ loader_progress: "loader_campaign_list" });
    fetch("/leadRoutes/filterOptions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ filterValues: updatedFilterValues }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
           loader_progress: "" , //Nilesh-5733-Add loader
          clientNames: data.clientNames || [],
          campIDs: data.campIDs || [],
          users: data.users || [],
          campaignStatuses: data.campaignStatuses || [],
          campIdStatusMap: data.campIdStatusMap || {},
        });
      })
      .catch((err) => {
        console.error("Error updating filter options:", err);
      });
  };

  backButtonHandleChange = (e) => {
    e.preventDefault();
    this.props.history.push("/newPublisherDashboard"); //move to the dashboard
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      showDropdown: !prevState.showDropdown,
    }));
  };

  // for selecting all fields
  handleToggleSelectAll = (e) => {
    const { checked } = e.target;
    const { allFields, mandatoryFields } = this.state;

    const nonMandatoryFields = allFields.filter(
      (field) => !mandatoryFields.has(field)
    );

    this.setState({
      selectedFields: checked ? nonMandatoryFields : [],
    });
  };

  // end of selecting all fields

  handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    this.setState(
      (prevState) => {
        let selectedOptions = [...prevState.selectedOptions];
        let filterValues = { ...prevState.filterValues };

        if (checked) {
          selectedOptions.push(value);
        } else {
          selectedOptions = selectedOptions.filter((item) => item !== value);

          if (value === "Date Range") {
            delete filterValues["Date Range From"];
            delete filterValues["Date Range To"];
          } else if (value === "Lead Status") {
            delete filterValues["Lead Status"];
          } else if (value === "Campaign Status") {
            //Anshul 5707
            delete filterValues["Campaign Status"]; //Anshul 5707
          } else {
            delete filterValues[value];
          }
        }

        return {
          selectedOptions,
          filterValues,
          ...(value === "Lead Status" ? { leadStatus: [] } : {}),
          ...(value === "Campaign Status" ? { campaignStatus: [] } : {}),
        };
      },
      () => {
        this.fetchFilterOptions(this.state.filterValues);
      }
    );
  };

  handleFilterValueChange = (key, value) => {
    this.setState(
      (prevState) => ({
        filterValues: {
          ...prevState.filterValues,
          [key]: value,
        },
      }),
      () => {
        this.fetchFilterOptions(this.state.filterValues);
      }
    );
  };

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showDropdown: false });
    }
  };

  //Nilesh-5733- removed unnecessary code
  // componentDidMount() {
    // this.fetchFilterOptions({}); // Load all filter data initially
    //fetch client name
    // fetch("/leadRoutes/clientname", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       clientNames: data.clientNames || [],
    //     });
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching data: ", error);
    //   });

    //fetch camp ID
    // fetch("/leadRoutes/campid", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       campIDs: data.campIDs || [],
    //     });
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching data: ", error);
    //   });

    //fetch Users
    // fetch("/leadRoutes/users", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       users: data.users || [],
    //     });
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching data: ", error);
    //   });
  // }

  // Anshul 5707 - modified renderFilterInput to fetch campaign id correctly
  renderFilterInput = (filterKey) => {
    const {
      filterValues,
      clientNames = [],
      campIDs = [],
      users = [],
    } = this.state;

    let options = [];
    let placeholder = `Select ${filterKey}`;
    let selectOptions = [];

    if (filterKey === "Client Name") {
      options = clientNames;
      placeholder = "Select Client Name";
      selectOptions = Array.isArray(options)
        ? options.map((item) => ({
            value: item,
            label: item,
          }))
        : [];
    } else if (filterKey === "User") {
      options = users;
      placeholder = "Lead Uploaded By";
      selectOptions = Array.isArray(options)
        ? options.map((item) => ({
            value: item,
            label: item,
          }))
        : [];
    } else if (filterKey === "Campaign ID") {
      options = campIDs || [];
      placeholder = "Select Campaign ID";

      const { campIdStatusMap, campaignStatus } = this.state;

      const selectedStatuses = campaignStatus.map((s) => s.name);

      if (selectedStatuses.length > 0) {
        options = options.filter((item) => {
          const parts = item.split(" - ");
          const campId = parts.length > 1 ? parts[1] : item;
          const backendStatus = campIdStatusMap[campId];

          let uiStatus = "";
          if (backendStatus === "Active") uiStatus = "Active";
          else if (["Live_Incomplete", "Completed"].includes(backendStatus))
            uiStatus = "Completed";

          return selectedStatuses.includes(uiStatus);
        });
      }

      selectOptions = options.map((item) => {
        const parts = item.split(" - ");
        return {
          value: parts.length > 1 ? parts[1] : item,
          label: item,
        };
      });
    }

    const selectedValue = selectOptions.find(
      (opt) => opt.value === filterValues[filterKey]
    );

    return (
      <div style={{ width: "100%" }}>
        <Select
          className="react-select__control_leadreport"
          options={selectOptions}
          isSearchable
          placeholder={placeholder}
          value={selectedValue || null}
          onChange={(selected) => {
            const value = selected ? selected.value : "";
            this.handleFilterValueChange(filterKey, value);

            const { campIdStatusMap } = this.state;
            const actualStatusRaw = campIdStatusMap?.[value];

            let uiStatus = "";
            //  if (actualStatusRaw === "Accept") uiStatus = "Active";
            // Anshul-5715 : changed 'Accept' to 'Active' for camp status
            if (actualStatusRaw === "Active") uiStatus = "Active";
            else if (["Live_Incomplete", "Completed"].includes(actualStatusRaw))
              uiStatus = "Completed";

            if (
              uiStatus &&
              this.state.selectedOptions.includes("Campaign Status") &&
              this.state.campaignStatus.length === 0
            ) {
              const statusObj = campaignStatusOptions.find(
                (s) => s.name === uiStatus
              );
              if (statusObj) {
                this.onCampaignStatusHandleChange([statusObj]);
              }
            }
          }}
          styles={{
            control: (base) => ({
              ...base,
              minHeight: "34px",
              fontSize: "14px",
              fontFamily: "sans-serif",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 9999,
              maxHeight: "200px",
              overflowY: "auto",
            }),
            menuList: (base) => ({
              ...base,
              maxHeight: "200px",
              overflowY: "auto",
            }),
          }}
        />
      </div>
    );
  }; // Anshul 5707 - end  modified renderFilterInput to fetch campaign id correctly

  // case "Lead Status":
  //   return (
  //     <select
  //       style={{ minHeight: "33px", cursor: "pointer" }}
  //       className="form-control"
  //       value={this.state.filterValues[filterKey] || ""}
  //       onChange={(e) =>
  //         this.handleFilterValueChange(filterKey, e.target.value)
  //       }
  //     >
  //       <option value="">Select Status</option>
  //       <option value="Delivered">Delivered</option>
  //       <option value="Review-Pending">Review-Pending</option>
  //       <option value="Rejected">Rejected</option>
  //     </select>
  //   );

  onLeadStatusHandleChange = (selected) => {
    this.setState((prevState) => ({
      leadStatus: selected,
      filterValues: {
        ...prevState.filterValues,
        "Lead Status": selected.map((item) => item.name),
      },
    }));
  };

  handleFieldChange = (field) => {
    this.setState((prevState) => {
      const selected = new Set(prevState.selectedFields);
      if (selected.has(field)) {
        selected.delete(field);
      } else {
        selected.add(field);
      }
      return { selectedFields: Array.from(selected) };
    });
  };
  handleDateChange = (type, value) => {
    this.setState({ [type]: value });
  };

  //Handle lead count
  handleSearchButton = () => {
    const { filterValues, selectedFields, mandatoryFields, selectedOptions } =
      this.state;
    const missingFields = [];

    for (const key of selectedOptions) {
      if (key === "Date Range") {
        const startDate = filterValues["Date Range From"];
        const endDate = filterValues["Date Range To"];
        if (!startDate || !endDate || new Date(startDate) > new Date(endDate)) {
          missingFields.push("Valid Date Range (Start and End Dates)");
        }
      } else {
        const value = filterValues[key];
        if (!value || value === key) {
          missingFields.push(key);
        }
      }
    }

    // if (missingFields.length > 0) {
    //   Swal.fire({
    //     type: "warning",
    //     title: "Please Select Filter Values",
    //     confirmButtonText: "Ok",
    //     allowOutsideClick: false,
    //   });
    //   return;
    // }

    // Anshul 5707 - added below line to update the count to 0 when filter is applied
    this.setState({
      loader_progress: "loader_campaign_list",
      totalLeadCount: 0, //  reset count before making API call
    });

    fetch("/leadRoutes/leadCount", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filterValues }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error fetching count");
        return res.json();
      })
      .then((data) => {
        this.setState({ loader_progress: "" });

        if (data.leadCount === 0) {
          Swal.fire({
            type: "warning",
            title: "No records Found",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            // preConfirm: () => {
            //   window.location.reload();
            // },
          });
        } else {
          this.setState({ totalLeadCount: data.leadCount });
        }
      })
      .catch((err) => {
        console.error("Lead count fetch error:", err);
        this.setState({ loader_progress: "" });
      });
  }; // end of handle lead count

  createWorkbook = (rows) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    if (rows.length > 0) {
      worksheet.columns = Object.keys(rows[0]).map((key) => ({
        header: key,
        key: key,
      }));
      worksheet.addRows(rows);
    }

    return workbook;
  };

  handleDownload = async () => {
    const { filterValues, mandatoryFields, selectedFields } = this.state;
    const mergedFields = Array.from(
      new Set([...mandatoryFields, ...selectedFields])
    );

    this.setState({ loader_progress: "loader_campaign_list" }, () => {
      setTimeout(async () => {
        try {
          const response = await fetch("/leadRoutes/leadData", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filterValues,
              selectedFields: mergedFields,
            }),
          });

          if (!response.ok) throw new Error("Error fetching lead data");

          const data = await response.json();
          const leads = data.results || [];

          if (leads.length === 0) {
            this.setState({ loader_progress: "" });
            Swal.fire("No Data", "No lead data found.", "info");
            return;
          }

          if (leads.length <= 20000) {
            const workbook = this.createWorkbook(leads);
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), "Lead_Report.xlsx");
          } else {
            const zip = new JSZip();
            const batches = Math.ceil(leads.length / 20000);

            for (let i = 0; i < batches; i++) {
              const batchData = leads.slice(i * 20000, (i + 1) * 20000);
              const workbook = this.createWorkbook(batchData);
              const buffer = await workbook.xlsx.writeBuffer();
              zip.file(`Lead_Batch_${i + 1}.xlsx`, buffer);
            }

            const zipBlob = await zip.generateAsync({ type: "blob" });
            saveAs(zipBlob, "Lead_Report.zip");
          }

          this.setState({ loader_progress: "" });

          Swal.fire({
            html: "Report downloaded successfully.",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        } catch (err) {
          console.error("Error generating Excel:", err);
          this.setState({ loader_progress: "" });
          Swal.fire("Error", "Failed to download report", "error");
        }
      }, 100);
    });
  };

  // Anshul 5707 - Added to handle the Campaign Status

  onCampaignStatusHandleChange = (selected) => {
    const selectedValues = selected.map((item) => item.name);
    this.setState(
      (prevState) => ({
        campaignStatus: selected,
        filterValues: {
          ...prevState.filterValues,
          "Campaign Status": selectedValues,
        },
      }),
      () => {
        this.fetchFilterOptions(this.state.filterValues);
      }
    );
  };

  // Anshul 5707 - Disabled the search button untill filter values does not selected
  isAllFiltersValid = () => {
    const { selectedOptions, filterValues } = this.state;

    if (selectedOptions.length === 0) return false;

    for (const key of selectedOptions) {
      if (key === "Date Range") {
        const start = filterValues["Date Range From"];
        const end = filterValues["Date Range To"];
        if (!start || !end || new Date(start) > new Date(end)) return false;
      } else {
        const val = filterValues[key];
        if (!val || val === key || val.length === 0) return false;
      }
    }

    return true;
  };

  render() {
    //  Anshul 5707 - Anshul added new filter (Campaign Status)
    const allFilterOptions = [
      "Campaign ID",
      "Campaign Status",
      "Client Name",
      "User",
      "Lead Status",
      "Date Range",
    ];

    const {
      selectedOptions,
      showDropdown,
      allFields,
      mandatoryFields,
      selectedFields,
      totalLeadCount,
    } = this.state;

    return (
      <div>
        <PublisherNavigation />

        <div
          className=" customized-lead-container px-4"
          style={{ marginTop: "100px" }}
        >
          {/* Anshul 5707 - below lines added to move title at centre */}
          <div className="lead-report-header customized d-flex align-items-center mb-4 px-2">
            {/* back button - fixed on left */}
            <div style={{ minWidth: "65px" }}>
              <a
                href={"#/"}
                onClick={this.backButtonHandleChange}
                style={{ color: "#056eb8" }}
              >
                <FaArrowAltCircleLeft size={32} title="Back to Dashboard" />
              </a>
            </div>

            {/* title - centered */}
            <div className="flex-grow-1 text-center">
              <label
                id="labelDI"
                className="lead-report-title customized-title"
              >
                Customized Lead Report
              </label>
            </div>

            {/* empty div for balance - same width as back button */}
            <div style={{ minWidth: "65px" }}></div>
          </div>

          <div
            className="filter-card"
            style={{ padding: "20px", width: "100%" }}
          >
            <h5
              style={{
                color: "#F28C0F",
                fontFamily: "Roboto",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              Input Fields For Report:
            </h5>

            <hr className="my-2" style={{ color: "lightgrey" }} />

            <div className="row align-items-start">
              <div className="col-md-4">
                <label
                  style={{
                    color: "#193D8f",
                    margin: 0,
                    whiteSpace: "nowrap",
                    minHeight: "20px",
                    borderRadius: "1px",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Select Input Filters<span style={{ color: "red" }}> *</span> :
                </label>

                <div
                  className="dropdown mt-2"
                  ref={this.dropdownRef}
                  style={{ position: "relative", marginLeft: "10px" }}
                >
                  <div
                    onClick={this.toggleDropdown}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #CCCCCC",
                      borderRadius: "3px",
                      backgroundColor: "#FFFFFF",
                      fontFamily: "sans-serif",
                      color: "#555555",
                      fontSize: "14px",
                      cursor: "pointer",
                      width: "100%",
                      minHeight: "36px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      minWidth: "170px",
                    }}
                  >
                    <span>
                      {selectedOptions.length === 0
                        ? "Select Filters"
                        : // Anshul 5707 - updated filter value from 5 to 6
                          `${selectedOptions.length} out of 6 Filters Selected`}
                    </span>
                    <span style={{ fontSize: "10px", marginLeft: "10px" }}>
                      ⮟
                    </span>
                  </div>

                  {showDropdown && (
                    <div
                      className="dropdown-content"
                      style={{
                        position: "absolute",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        borderRadius: "5px",
                        zIndex: 1,
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "auto",
                        marginTop: "0px",
                      }}
                    >
                      {[
                        "Select All",
                        "Campaign ID",
                        "Campaign Status", // Anshul 5707 - Added new filter campaign status
                        "User",
                        "Client Name",
                        "Lead Status",
                        "Date Range",
                      ].map((option) => (
                        <label
                          key={option}
                          style={{
                            display: "block",
                            marginBottom: "5px",
                            color: "#495057",
                            fontWeight: "500",
                          }}
                        >
                          <input
                            style={{ cursor: "pointer" }}
                            type="checkbox"
                            value={option}
                            onChange={(e) => {
                              if (option === "Select All") {
                                const allOptions = allFilterOptions; // Anshul 5707 - updated allFilterOptions
                                if (e.target.checked) {
                                  this.setState(
                                    {
                                      selectedOptions: allOptions,
                                    },
                                    () => {
                                      this.fetchFilterOptions(
                                        this.state.filterValues
                                      );
                                    }
                                  );
                                } else {
                                  this.setState(
                                    {
                                      selectedOptions: [],
                                      filterValues: {},
                                      leadStatus: [],
                                      campaignStatus: [], //Anshul-5716 clear the camp status  for select all
                                    },
                                    () => {
                                      this.fetchFilterOptions({});
                                    }
                                  );
                                }
                              } else {
                                this.handleCheckboxChange(e);
                              }
                            }}
                            checked={
                              option === "Select All"
                                ? selectedOptions.length ===
                                  allFilterOptions.length
                                : selectedOptions.includes(option)
                            }
                          />{" "}
                          {option}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* loader */}

              <div align="center" id={this.state.loader_progress}></div>

              {/* Filters */}
              <div className="col-md-8">
                {selectedOptions.length === 0 ? (
                  <div
                    style={{
                      color: "red",
                      fontWeight: 500,
                      fontSize: "16px",
                      marginTop: "13px",
                      //  marginLeft: "-170px",
                    }}
                  >
                    *Please select at least one filter to fetch data.
                  </div>
                ) : (
                  <>
                    <div
                      className="filter-card"
                      style={{
                        border: "0.2px solid #CCCCCC",
                        padding: "20px",
                      }}
                    >
                      <div className="custom-lead-filters row">
                        {selectedOptions.map((option) => {
                          if (option.toLowerCase() === "date range") {
                            return (
                              <React.Fragment key="date-range">
                                {/* Start Date */}
                                <div className="col-md-4 mb-2 d-flex align-items-center">
                                  <label
                                    style={{
                                      color: "#193D8f",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      marginRight: "8px",
                                    }}
                                  >
                                    Start Date:
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    style={{ width: "100%" }}
                                    value={
                                      this.state.filterValues[
                                        "Date Range From"
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      this.handleFilterValueChange(
                                        "Date Range From",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                {/* End Date */}
                                <div className="col-md-4 mb-2 d-flex align-items-center">
                                  <label
                                    style={{
                                      color: "#193D8f",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      marginRight: "8px",
                                    }}
                                  >
                                    End Date:
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    style={{ maxWidth: "180px" }}
                                    value={
                                      this.state.filterValues[
                                        "Date Range To"
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      this.handleFilterValueChange(
                                        "Date Range To",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </React.Fragment>
                            );
                          } else if (option.toLowerCase() === "lead status") {
                            return (
                              <div
                                key={option}
                                className="col-md-4 mb-2 d-flex align-items-center position-relative"
                              >
                                <label
                                  style={{
                                    color: "#193D8f",
                                    marginRight: "8px",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}:
                                </label>
                                <div style={{ flex: 1 }}>
                                  <Picky
                                    value={this.state.leadStatus}
                                    options={leadStatusOptions}
                                    onChange={this.onLeadStatusHandleChange}
                                    open={false}
                                    valueKey="id"
                                    labelKey="name"
                                    multiple={true}
                                    placeholder={"Select Status"}
                                    includeSelectAll={true}
                                    dropdownHeight={200}
                                    numberDisplayed={0}
                                    id="leadStatus"
                                    name="leadStatus"
                                    className={`pc-lead-report-PickyStyle`}
                                    style={{
                                      minHeight: "33px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                          // Anshul 5707 - Added new filter campaign status
                          else if (option.toLowerCase() === "campaign status") {
                            return (
                              <div
                                key={option}
                                className="col-md-4 mb-2 d-flex align-items-center position-relative"
                              >
                                <label
                                  style={{
                                    color: "#193D8f",
                                    marginRight: "8px",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}:
                                </label>
                                <div style={{ flex: 1 }}>
                                  <Picky
                                    value={this.state.campaignStatus}
                                    options={campaignStatusOptions}
                                    onChange={this.onCampaignStatusHandleChange}
                                    open={false}
                                    valueKey="id"
                                    labelKey="name"
                                    multiple={true}
                                    includeSelectAll={true}
                                    includeFilter={false}
                                    placeholder="Select Status"
                                    dropdownHeight={200}
                                    numberDisplayed={0}
                                    id="CampaignStatus"
                                    name="CampaignStatus"
                                    className={"pc-lead-report-PickyStyle"}
                                  />
                                </div>
                              </div>
                            ); // Anshul 5707 - end Added new filter campaign status
                          } else {
                            return (
                              <div
                                key={option}
                                className="col-md-4 mb-2 d-flex align-items-center"
                              >
                                <label
                                  style={{
                                    color: "#193D8f",
                                    marginRight: "8px",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}:
                                </label>
                                <div style={{ flex: 1 }}>
                                  {this.renderFilterInput(option)}
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn add-button action-button"
                          style={{ width: "90px" }}
                          onClick={() => this.handleSearchButton()}
                          disabled={!this.isAllFiltersValid()}
                          title={
                            !this.isAllFiltersValid()
                              ? "Please fill all selected filter values"
                              : ""
                          }
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {selectedOptions.length === 0 ? null : (
              <>
                <hr className="my-8" style={{ color: "lightgrey" }} />

                <div
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#F28C0F",
                    paddingLeft: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    marginLeft: "-10px",
                  }}
                >
                  Output Fields For Report :
                  <input
                    type="checkbox"
                    checked={allFields
                      .filter((field) => !mandatoryFields.has(field))
                      .every((field) => selectedFields.includes(field))}
                    onChange={this.handleToggleSelectAll}
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    style={{
                      fontWeight: 400,
                      fontSize: "13px",
                      color: "black",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      marginTop: "6px",
                    }}
                  >
                    Select All
                  </label>
                  {/* tooltip */}
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <li>
                          {
                            "The 'Select All' option will select all the listed fields below. Fields that are disabled are mandatory and cannot be unselected."
                          }
                        </li>
                      </React.Fragment>
                    }
                  >
                    <Icon type="question-circle" />
                  </HtmlTooltip>
                </div>

                <hr className="mt-1" style={{ color: "lightgrey" }} />

                <div
                  className="row"
                  style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    padding: "10px",
                    borderRadius: "1px",
                    marginBottom: "10px",
                  }}
                >
                  {allFields.map((field) => {
                    const isMandatory = mandatoryFields.has(field);
                    const isChecked =
                      isMandatory || selectedFields.includes(field);

                    return (
                      <div className="col-md-6 mb-2" key={field}>
                        <label
                          style={{
                            fontWeight: "normal",
                            color: isMandatory
                              ? "rgba(0, 0, 0, 0.41)"
                              : "rgba(0, 0, 0, 1)",
                            display: "block",
                            cursor: isMandatory ? "not-allowed" : "pointer",
                            opacity: 1,
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            disabled={isMandatory}
                            onChange={() => this.handleFieldChange(field)}
                            style={{
                              marginRight: "8px",
                              accentColor: "#0d6efd",
                              cursor: isMandatory ? "not-allowed" : "pointer",
                            }}
                          />
                          {field}
                        </label>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                    whiteSpace: "nowrap",
                    width: "100%",
                  }}
                >
                  <h5
                    style={{
                      color: "#F28C0F",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: 0,
                      marginRight: "10px",
                    }}
                  >
                    Total Lead Count: {totalLeadCount}
                  </h5>

                  <div className="row mt-3">
                    <div className="col d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn add-button action-button"
                        style={{ width: "90px" }}
                        onClick={this.handleDownload}
                        disabled={totalLeadCount <= 0}
                        title={
                          totalLeadCount <= 0
                            ? "No leads available to download"
                            : ""
                        }
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>
                <hr style={{ color: "lightgrey" }} />
              </>
            )}
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
customizedLeadReport.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(
  withRouter(customizedLeadReport)
);
